import {
  getGetRequestInit,
  getPostRequestInit,
  getProxyServicePath,
  retrieveData,
} from './common';
import { EVENT_API_SERVICE_HOSTS } from './config';
import utils from '../utils';
const isEventApi = true;
const serviceEndpoint = utils.shouldBypassCloudProxy(isEventApi) ?
  utils.generateEventAPIUrl(EVENT_API_SERVICE_HOSTS.production)
  : getProxyServicePath(EVENT_API_SERVICE_HOSTS);

export const getDashboardInsightsData = async (
  { brandIds, startDate, endDate, filters, token },
) => {
  const url = `${serviceEndpoint}/v1/insights`;

  const postBody = {
    brandIds,
    dateRange: { startDate, endDate },
    filters,
  };

  const requestInit = getPostRequestInit(postBody, token);

  return await retrieveData(url, requestInit);
};

export const getDashboardSalesInsightsData = async (
  { brandIds, startDate, endDate, filters, activeView, token },
) => {
  const url = `${serviceEndpoint}/v1/salesInsights`;

  const postBody = {
    brandIds,
    dateRange: { startDate, endDate },
    filters,
    activeView,
  };

  const requestInit = getPostRequestInit(postBody, token);

  return await retrieveData(url, requestInit);
};


export const getDashboardFilterValues = async (
  { brandIds, startDate, endDate, dimension, activeView },
  token,
) => {
  const url = `${serviceEndpoint}/v1/filters` +
    `?name=${dimension}` +
    `&brandIds=${brandIds}` +
    `&startDate=${startDate}` +
    `&endDate=${endDate}` +
    `&activeView=${activeView}`;

  const requestInit = getGetRequestInit(token);

  return await retrieveData(url, requestInit);
};

export const getDashboardExplorerData = async (postBody, token) => {
  const url = `${serviceEndpoint}/v1/explorer`;

  const requestInit = getPostRequestInit(postBody, token);

  return await retrieveData(url, requestInit);
};

export const getDemographicsFilterValues = async (
  { dimension, brandIds, startDate, endDate },
  token,
) => {
  const url = `${serviceEndpoint}/v1/demographics/filters` +
    `?dimension=${dimension}` +
    `&brandIds=${brandIds}` +
    `&startDate=${startDate}` +
    `&endDate=${endDate}`;

  const requestInit = getGetRequestInit(token);

  return await retrieveData(url, requestInit);
};

export const getDemographicsReport = async (postBody, token) => {
  const url = `${serviceEndpoint}/v1/demographics/report`;

  const requestInit = getPostRequestInit(postBody, token);

  return await retrieveData(url, requestInit);
};

export const getDemographicsOverview = async (
  { brandIds, startDate, endDate, filters, token },
) => {
  const url = `${serviceEndpoint}/v1/demographics/overview`;

  const postBody = {
    brandIds,
    dateRange: { startDate, endDate },
    filters,
  };

  const requestInit = getPostRequestInit(postBody, token);

  return await retrieveData(url, requestInit);
};

export const getDemographicsAllSegmentsReport = async (postBody, token) => {
  const url = `${serviceEndpoint}/v1/demographics/segments`;

  const requestInit = getPostRequestInit(postBody, token);

  return await retrieveData(url, requestInit);
};

